/* eslint-disable no-bitwise */
export const EditorialComponent =
    {
      None: 0,
      Keyword: 1,
      KeywordParam1: 2,
      KeywordParam2: 4,
      KeywordParam3: 8,
      AdTitleDescription: 256,
      AdTitle: 512,
      AdDescription: 1024,
      DisplayUrl: 2048,
      DestinationUrl: 4096,
      LandingURL: 8192,
      SiteDomain: 16384,
      BusinessName: 32768,
      PhoneNumber: 65536,
      AltText: 262144,
      Audio: 524288,
      Video: 1048576,
      Flash: 2097152,
      CAsset: 4194304,
      Image: 8388608,
      Destination: 16777216,
      Asset: 33554432,
      Ad: 67108864,
      Order: 134217728,
      OrderItem: 268435456,
      Association: 536870912,
      Script: 1073741824,
    };

export function getLocationString({ location, commonI18n }) {
  const locations = [];
  if ((location & EditorialComponent.AdTitle) === EditorialComponent.AdTitle) {
    locations.push(commonI18n.getString('EdReason_AdTitle'));
  }

  if ((location & EditorialComponent.AdTitleDescription)
    === EditorialComponent.AdTitleDescription) {
    locations.push(commonI18n.getString('EdReason_AdTitleDesc'));
  }

  if ((location & EditorialComponent.AdDescription) === EditorialComponent.AdDescription) {
    locations.push(commonI18n.getString('EdReason_AdDesc'));
  }

  if ((location & EditorialComponent.DisplayUrl) === EditorialComponent.DisplayUrl) {
    locations.push(commonI18n.getString('EdReason_DisplayUrl'));
  }

  if ((location & EditorialComponent.DestinationUrl) === EditorialComponent.DestinationUrl) {
    locations.push(commonI18n.getString('EdReason_AdDestUrl'));
  }

  if ((location & EditorialComponent.BusinessName) === EditorialComponent.BusinessName) {
    locations.push(commonI18n.getString('EdReason_BusinessName'));
  }

  if ((location & EditorialComponent.PhoneNumber) === EditorialComponent.PhoneNumber) {
    locations.push(commonI18n.getString('EdReason_PhoneNumber'));
  }

  if ((location & EditorialComponent.Keyword) === EditorialComponent.Keyword) {
    locations.push(commonI18n.getString('EdReason_Keyword'));
  }

  if ((location & EditorialComponent.KeywordParam1) === EditorialComponent.KeywordParam1) {
    locations.push(commonI18n.getString('EdReason_Param1'));
  }

  if ((location & EditorialComponent.KeywordParam2) === EditorialComponent.KeywordParam2) {
    locations.push(commonI18n.getString('EdReason_Param2'));
  }

  if ((location & EditorialComponent.KeywordParam3) === EditorialComponent.KeywordParam3) {
    locations.push(commonI18n.getString('EdReason_Param3'));
  }

  if ((location & EditorialComponent.LandingURL) === EditorialComponent.LandingURL) {
    locations.push(commonI18n.getString('EdReason_LandingUrl'));
  }

  if ((location & EditorialComponent.SiteDomain) === EditorialComponent.SiteDomain) {
    locations.push(commonI18n.getString('EdReason_SiteDomain'));
  }

  if ((location & EditorialComponent.Image) === EditorialComponent.Image) {
    locations.push(commonI18n.getString('EdReason_Image'));
  }

  if ((location & EditorialComponent.AltText) === EditorialComponent.AltText) {
    locations.push(commonI18n.getString('EdReason_AltText'));
  }

  if ((location & EditorialComponent.Flash) === EditorialComponent.Flash) {
    locations.push(commonI18n.getString('EdReason_Flash'));
  }

  if ((location & EditorialComponent.Audio) === EditorialComponent.Audio) {
    locations.push(commonI18n.getString('EdReason_Audio'));
  }

  if ((location & EditorialComponent.Video) === EditorialComponent.Video) {
    locations.push(commonI18n.getString('EdReason_Video'));
  }

  if ((location & EditorialComponent.CAsset) === EditorialComponent.CAsset) {
    locations.push(commonI18n.getString('EdReason_CAsset'));
  }

  if ((location & EditorialComponent.Asset) === EditorialComponent.Asset) {
    locations.push(commonI18n.getString('EdReason_Asset'));
  }

  if ((location & EditorialComponent.Ad) === EditorialComponent.Ad) {
    locations.push(commonI18n.getString('EdReason_Ad'));
  }

  if ((location & EditorialComponent.Order) === EditorialComponent.Order) {
    locations.push(commonI18n.getString('EdReason_Order'));
  }

  if ((location & EditorialComponent.OrderItem) === EditorialComponent.OrderItem) {
    locations.push(commonI18n.getString('EdReason_OrderItem'));
  }

  if ((location & EditorialComponent.Destination) === EditorialComponent.Destination) {
    locations.push(commonI18n.getString('EdReason_AdDestUrl'));
  }

  if ((location & EditorialComponent.Association) === EditorialComponent.Association) {
    locations.push(commonI18n.getString('EdReason_Association'));
  }

  if ((location & EditorialComponent.Script) === EditorialComponent.Script) {
    locations.push(commonI18n.getString('EdReason_Script'));
  }

  // javascript has overflowing issue for big numbers such as Math.pow(2, 60)
  // use comparation instead
  // eslint-disable-next-line no-restricted-properties
  if (location && location > Math.pow(2, 59) && location <= Math.pow(2, 60)) {
    locations.push(commonI18n.getString('EdReason_DataFeedItem'));
  }

  return locations.join(', ');
}
